import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from '../Avatar/Avatar';
import { CircleStack } from '../CircleStack/CircleStack';
import styles from './AvatarStack.module.css';
export function AvatarStack({ people, size = 26, max = 4, 'aria-label': ariaLabel, }) {
    const visible = people.slice(0, max);
    const overflow = people.length - visible.length;
    const items = visible.map((person) => ({ kind: 'person', person }));
    if (overflow > 0)
        items.push({ kind: 'overflow', count: overflow });
    const summary = ariaLabel ??
        (overflow > 0
            ? `${people.length} people (${overflow} more not shown)`
            : `${people.length} ${people.length === 1 ? 'person' : 'people'}`);
    return (_jsx("div", { role: "group", "aria-label": summary, style: { display: 'inline-flex' }, children: _jsx(CircleStack, { items: items, size: size, max: items.length, renderItem: (item) => item.kind === 'person' ? (_jsx(Avatar, { src: item.person.photo, name: item.person.name, size: size, ...(item.person.href ? { href: item.person.href } : {}), ...(item.person.linkAs ? { linkAs: item.person.linkAs } : {}) })) : (_jsx(OverflowTile, { count: item.count, size: size })) }) }));
}
function OverflowTile({ count, size }) {
    return (_jsxs("div", { role: "img", "aria-label": `${count} more`, className: styles.overflow, style: { width: size, height: size, fontSize: Math.round(size * 0.4) }, children: ["+", count] }));
}
//# sourceMappingURL=AvatarStack.js.map